import type { NoteCheckFinding } from '../fhirNoteMapping';

const DEFAULT_FINDING_LABEL_MAX_LENGTH = 60;

export function truncateFindingLabel(label: string, maxLength = DEFAULT_FINDING_LABEL_MAX_LENGTH): string {
  const trimmed = label.trim();
  if (trimmed.length <= maxLength) return trimmed;
  return `${trimmed.slice(0, maxLength - 1).trimEnd()}…`;
}

/** Compact preview for long finding lists — first label (truncated) plus "+N more". */
export interface FindingsPreviewParts {
  label: string;
  moreCount: number;
}

export function buildFindingsPreview(
  findings: NoteCheckFinding[],
  options?: { maxLabelLength?: number },
): FindingsPreviewParts | undefined {
  if (findings.length === 0) return undefined;
  const maxLabelLength = options?.maxLabelLength ?? DEFAULT_FINDING_LABEL_MAX_LENGTH;
  return {
    label: truncateFindingLabel(findings[0].location, maxLabelLength),
    moreCount: findings.length - 1,
  };
}

export function formatFindingsPreview(
  findings: NoteCheckFinding[],
  options?: { maxLabelLength?: number },
): string | undefined {
  const preview = buildFindingsPreview(findings, options);
  if (!preview) return undefined;
  if (preview.moreCount === 0) return preview.label;
  return `${preview.label} +${preview.moreCount} more`;
}

export function formatNoteCheckFindings(findings: NoteCheckFinding[]): string {
  return findings.map((f) => `${f.location}: ${f.message}`).join('\n');
}
